export const roleHomePaths = {
    tenant: '/tenant',
    landlord: '/landlord'
};

export const roleDisplayNames = {
    tenant: 'Tenant',
    landlord: 'Landlord'
}

export const getRoleBasedRedirect = (user) => {
    return { homePath: roleHomePaths[user?.role] || '/login' };
};

export const getRoleType = (user) => {
    return roleDisplayNames[user?.role] || '';
};